import { LanguagesService } from '@alpha-core/platform-ui';
import { ChangeDetectorRef, DestroyRef, Pipe, PipeTransform, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Pipe({
    name: 'pTranslate',
    pure: false,
    standalone: true,
})
export class PUITranslatePipe implements PipeTransform {
    private languageService = inject(LanguagesService);
    private changeDetector = inject(ChangeDetectorRef);

    destroyRef = inject(DestroyRef);
    constructor() {
        this.languageService.selectedLanguage$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((language) => {
            this.changeDetector.markForCheck();
        });
    }

    transform(key: string | undefined, defaultValue: string = '', obj: Record<string, any> = {}): string {
        if (!key) {
            return defaultValue || '';
        }

        const translation = this.languageService.getTranslation(key);
        if (obj && Object.keys(obj).length > 0) {
            return this.updateValue(translation || defaultValue, obj);
        }
        return translation || defaultValue;
    }

    private updateValue(text: string, obj: Record<string, any> = {}): string {
        return this.languageService.translate(text, obj as any);
    }
}
